import { inject, Injectable } from '@angular/core';
import { ApiService } from '@okcargo-apps/services';
import { NotificationQuery, NotificationQueryRepository, NotificationResponse } from '@okcargo/query-processor';
import { ServerEventListenerService } from './server-event-listener.service';

@Injectable({
  providedIn: 'root',
})
export class BaseServerEventQueryRepository implements NotificationQueryRepository {
  private readonly apiService = inject(ApiService);
  private readonly serverEventListener = inject(ServerEventListenerService);

  public resourceUrl = this.apiService.API_URL + '/service/query-processor/api/queries';

  execute<T extends NotificationResponse, U extends Response>(name: string, query: NotificationQuery): void {
    this.serverEventListener.getServerSentEvent<T>(
      // Important: `ngsw-bypass=true` prevents the Service Worker from caching the connection and therefore killing the process after 5 minutes.
      `${this.resourceUrl}?ngsw-bypass=true&name=${name}&payload=${encodeURI(JSON.stringify(query))}`,
    );
  }
}
